var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container orders-view"},[_c('OrderList',{on:{"choosed":_vm.toDetail,"action":_vm.goIndex}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }